// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__XRsbQ","spinner-c7wet2":"Spinner_spinner-c7wet2__TkJVb","white":"Spinner_white__U9Qfy"};